import * as React from "react";
import Timestamp from "components/common/Timestamp";
const pluginExports = {
  "markdown.augment.components": [
    {
      id: "ts",
      component: ({ value }) => /* @__PURE__ */ React.createElement("strong", null, /* @__PURE__ */ React.createElement(Timestamp, { dateTime: value }))
    }
  ]
};
export default pluginExports;
